import { getIssueTypes } from 'src/services/client';
import { useEffect, useState } from 'react';

interface UseFormOptionsReturn {
  servicesProvidedTypes: any[];
  isLoading: boolean;
  error: string | null;
  refetchSPTypes: () => Promise<void>;
}

export const useFetchServicesProvidedTypes = (): UseFormOptionsReturn => {
  const [servicesProvidedTypes, setServicesProvidedTypes] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchIssueTypes = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      const response: any = await getIssueTypes();

      if (response.ok || response.status === 200) {
        const data = await response.json();
        setServicesProvidedTypes(data);
      } else {
        setError('Failed to fetch issue types');
      }
    } catch (err) {
      console.error('Error fetching issue types:', err);
      setError('An error occurred while fetching issue types');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchIssueTypes();
  }, []);

  return {
    servicesProvidedTypes,
    isLoading,
    error,
    refetchSPTypes: fetchIssueTypes,
  };
};
